<style lang="scss" scoped>
.confirm-deletion {
	&__footer {
		margin-top: 30px;
	}
}
</style>

<template lang="pug"> 
    .confirm-deletion
        p Please enter <strong>{{ value }}</strong> and press confirm to continue.
        el-input(:placeholder='value', v-model="userInput", @keyup.enter.native="$vuedals.close(true)")
        .confirm-deletion__footer
            el-button(type="danger", :disabled='disabled', @click="$vuedals.close(true)") Confirm
            el-button(@click="$vuedals.close(false)") Cancel
</template>

<script>
export default {
	props: {
		value: {
			type: String,
			required: true
		}
	},
	data: () => ({
		userInput: null
	}),
	computed: {
		disabled() {
			return this.userInput !== this.value;
		}
	}
};
</script>
